import React from 'react';
import Layout from './src/components/Layout';
import smoothscroll from 'smoothscroll-polyfill';

import './src/scss/main.scss';

smoothscroll.polyfill();    // IE+Edge

export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;
